import { InsightData } from 'schemas/action/InsightDataSchema'
import { DayAndHourWidgetsType } from 'components/widget/DayAndHourWidgets/types'
import { DayHour } from 'schemas/DayHourSchema'

import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import { getRangeConfig } from '../utils/dayHours'
import MAX_INPUT_COUNT from './constants'

const containsAll = (containerArr?: any[] | null, targetArr?: any[] | null) => {
  if (!containerArr || !targetArr) return false
  return targetArr.every((target) => containerArr.includes(target))
}

const isEmptyArray = (targetArr?: any[] | null) => !targetArr || !targetArr.length

const isDurationAllDay = (duration?: number) => duration === 24 || duration === 0

const dayHourFilterMerge = (filter: DayHour, globalFilter?: DayHour): DayHour => {
  if (!globalFilter) {
    return filter
  }

  let mergedDays
  let mergedDuration
  let mergedStartHour

  if (isEmptyArray(globalFilter.days)) {
    if (filter.days) {
      mergedDays = filter.days
    }
  } else if (isEmptyArray(filter.days)) {
    if (globalFilter.days) {
      mergedDays = globalFilter.days
    }
  } else if (containsAll(globalFilter.days, filter.days)) {
    mergedDays = filter.days
  } else {
    return globalFilter
  }

  if (isDurationAllDay(globalFilter.duration)) {
    mergedDuration = filter.duration
    mergedStartHour = filter.startHour
  } else if (isDurationAllDay(filter.duration)) {
    mergedDuration = globalFilter.duration
    mergedStartHour = globalFilter.startHour
  } else {
    const pStart = globalFilter.startHour as number
    const pEnd = pStart + globalFilter.duration!
    const cStart = filter.startHour as number
    const cEnd = cStart + filter.duration!

    if (cStart < pStart || cEnd > pEnd) {
      return globalFilter
    }

    const start = Math.max(pStart, cStart)
    const end = Math.min(pEnd, cEnd)
    if (end > start) {
      mergedStartHour = start
      mergedDuration = end - start
    } else {
      return globalFilter
    }
  }

  const mergedFilter = {
    ...(!isEmptyArray(mergedDays) && { days: mergedDays }),
    duration: mergedDuration,
    startHour: mergedStartHour,
    timeZone: filter.timeZone
  }
  return mergedFilter
}

const canBeDrilledDown = (widgetSetting: DayAndHourWidgetsType) =>
  widgetSetting.dayHours === undefined ||
  widgetSetting.dayHours === null ||
  widgetSetting.dayHours.length < 2

const isOverMaxInput = (insights: InsightData[]) => insights.length > MAX_INPUT_COUNT

const composeDrillDownWidgetSetting = (
  widgetSetting: DayAndHourWidgetsType,
  insights: InsightData[]
) => {
  const dayHoursGlobalfilter = widgetSetting.dayHours?.[0]
  const currentFilter = {
    ...getRangeConfig(insights),
    timeZone: widgetSetting?.timeZoneOption
  }
  const mergedFilter = dayHourFilterMerge(currentFilter, dayHoursGlobalfilter)
  return {
    ...widgetSetting,
    dayHours: [mergedFilter]
  }
}

const generateDayHoursStrategy = (): WidgetSettingComposingStrategy<DayAndHourWidgetsType> => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateDayHoursStrategy
